export default __webpack_public_path__ + "static/media/img7.fcaa3fb5.jpg";